// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Site Settings — admin panel layout */
.settings-container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 4px 80px;
  box-sizing: border-box;
}

.settings-container .page-header {
  margin-bottom: 20px;
}

.settings-container .page-header h4 {
  font-size: 1.35rem;
  letter-spacing: 0.02em;
  color: #0f172a;
}

.settings-container .page-subtitle {
  color: #64748b;
  font-size: 0.9rem;
  margin: 0;
}

.settings-card {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.settings-form-inner {
  padding: 0;
}

/* Quick controls — always on top */
.ss-quick-bar {
  padding: 20px 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
  border-bottom: 1px solid #e2e8f0;
}

.ss-quick-bar__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.ss-quick-bar__title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.ss-quick-bar__hint {
  font-size: 12px;
  color: #64748b;
  margin: 4px 0 0;
}

.ss-quick-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.ss-quick-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.ss-quick-card:hover {
  border-color: #c7d2fe;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.08);
}

.ss-quick-card--off {
  border-color: #fecaca;
  background: #fffbfb;
}

.ss-quick-card--off .ss-quick-card__label {
  color: #991b1b;
}

.ss-quick-card__text {
  flex: 1 1;
  min-width: 0;
}

.ss-quick-card__label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.3;
}

.ss-quick-card__status {
  display: block;
  font-size: 11px;
  font-weight: 600;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ss-quick-card__status.on {
  color: #059669;
}

.ss-quick-card__status.off {
  color: #dc2626;
}

/* Tabs */
.ss-tabs-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 24px 0;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfc;
}

.ss-tab-btn {
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  background: transparent;
  border: none;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}

.ss-tab-btn:hover {
  color: #4f46e5;
  background: rgba(79, 70, 229, 0.06);
}

.ss-tab-btn.active {
  color: #4f46e5;
  background: #fff;
  border-bottom-color: #4f46e5;
}

.settings-content {
  padding: 24px;
}

.ss-tab-panel {
  animation: ssFadeIn 0.2s ease;
}

@keyframes ssFadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ss-panel {
  background: #fafbfc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 22px;
  margin-bottom: 20px;
}

.ss-panel:last-child {
  margin-bottom: 0;
}

.ss-panel--warn {
  background: #fffbeb;
  border-color: #fde68a;
}

.ss-panel--danger {
  background: #fef2f2;
  border-color: #fecaca;
}

.settings-section {
  margin-bottom: 0;
}

.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

.section-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin: 20px 0 12px;
}

.text-muted {
  display: block;
  font-size: 12px;
  color: #64748b;
  line-height: 1.45;
  margin-top: 6px;
}

.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 20px;
}

.grid-4 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.grid-span-full {
  grid-column: 1 / -1;
}

.form-group {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  color: #0f172a;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.form-input {
  height: 40px;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.form-textarea {
  min-height: 88px;
  resize: vertical;
  font-family: inherit;
  line-height: 1.5;
}

.form-textarea:disabled,
.form-input:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}

/* Toggle rows */
.ss-toggle-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ss-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.ss-toggle-row__label {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #cbd5e1;
  transition: 0.2s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  transition: 0.2s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

input:checked + .slider {
  background: #4f46e5;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.switch-label {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
}

.maintenance-section {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

.logo-section {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

.landing-game-preview {
  margin-top: 12px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #f4f4f5;
  max-width: 280px;
}

.landing-game-preview img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 140px;
  object-fit: cover;
}

.logo-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.logo-upload {
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  background: #fff;
  transition: border-color 0.15s;
}

.logo-upload:hover {
  border-color: #6366f1;
}

.logo-upload input {
  display: none;
}

.logo-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 10px;
  display: block;
}

.logo-upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background: #4f46e5;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.logo-upload-btn:hover {
  background: #4338ca;
}

.logo-remove {
  margin-top: 10px;
  font-size: 13px;
  color: #dc2626;
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

/* Sticky save */
.ss-sticky-save {
  position: sticky;
  bottom: 0;
  z-index: 20;
  display: flex;
  gap: 12px;
  padding: 16px 24px;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  border-top: 1px solid #e2e8f0;
  margin: 24px -24px -24px;
}

.action-buttons {
  display: flex;
  gap: 12px;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
}

.btn-primary {
  flex: 1 1;
  max-width: 320px;
  padding: 12px 24px;
  background: #4f46e5;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-primary:hover:not(:disabled) {
  background: #4338ca;
}

.btn-primary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 12px 20px;
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  border-top-color: #fff;
  animation: ssSpin 0.8s linear infinite;
}

.btn-secondary .spinner {
  border-color: rgba(51, 65, 85, 0.25);
  border-top-color: #334155;
}

@keyframes ssSpin {
  to {
    transform: rotate(360deg);
  }
}

/* Fake battles + danger + backup (unchanged structure) */
.fake-battle-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;
}

.fake-battle-card,
.danger-zone-card,
.backup-zone-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.fake-battle-card--running {
  border-color: #c7d2fe;
}

.fake-battle-card--running .fake-battle-header {
  background: #eef2ff;
}

.danger-zone-card {
  border-color: #fecaca;
}

.fake-battle-header,
.danger-zone-header,
.backup-zone-header {
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.danger-zone-header {
  background: #fef2f2;
  border-bottom-color: #fecaca;
}

.backup-zone-header {
  background: #eff6ff;
  border-bottom-color: #bfdbfe;
}

.fake-battle-title,
.danger-zone-title,
.backup-zone-title {
  font-size: 15px;
  font-weight: 700;
  margin: 0;
  color: #0f172a;
}

.danger-zone-title {
  color: #991b1b;
}

.backup-zone-title {
  color: #1e40af;
}

.fake-battle-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 12px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.stat-value {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.stat-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
}

.battle-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 20px;
}

.badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.badge-flash {
  background: #fef3c7;
  color: #b45309;
}
.badge-ten {
  background: #dbeafe;
  color: #1d4ed8;
}
.badge-high {
  background: #dcfce7;
  color: #15803d;
}
.badge-regular {
  background: #f3e8ff;
  color: #7c3aed;
}

.toggle-switch {
  display: flex;
  align-items: center;
  gap: 10px;
}

.toggle-btn {
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  position: relative;
  transition: background 0.2s;
}

.toggle-btn.enabled {
  background: #10b981;
}
.toggle-btn.disabled {
  background: #cbd5e1;
}

.toggle-btn:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  top: 2px;
  transition: left 0.2s, right 0.2s;
}

.toggle-btn.enabled:after {
  right: 2px;
  left: auto;
}
.toggle-btn.disabled:after {
  left: 2px;
}

.backup-zone-collapsed {
  margin-bottom: 16px;
}

.btn-backup-toggle {
  width: 100%;
  border: 1px dashed #93c5fd;
  background: #f8fafc;
  color: #1d4ed8;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.danger-zone-body,
.backup-zone-body {
  padding: 16px 20px;
}

.danger-zone-desc,
.backup-zone-desc {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
  margin: 0 0 14px;
}

.purge-preview-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 14px;
  font-size: 12px;
}

.danger-actions,
.backup-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.btn-danger-outline,
.btn-danger-solid,
.btn-backup-outline,
.btn-backup-solid {
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.btn-danger-outline {
  border: 1px solid #dc2626;
  background: #fff;
  color: #dc2626;
}

.btn-danger-solid {
  border: none;
  background: #dc2626;
  color: #fff;
}

.btn-backup-outline {
  border: 1px solid #2563eb;
  background: #fff;
  color: #2563eb;
}

.btn-backup-solid {
  border: none;
  background: #2563eb;
  color: #fff;
}

.btn-backup-hide {
  border: 1px solid #cbd5e1;
  background: #fff;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

@media (max-width: 900px) {
  .fake-battle-grid {
    grid-template-columns: 1fr;
  }

  .grid-2,
  .grid-4,
  .logo-grid {
    grid-template-columns: 1fr;
  }

  .ss-quick-grid {
    grid-template-columns: 1fr;
  }

  .ss-tabs-wrap {
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
  }

  .ss-tab-btn {
    white-space: nowrap;
    flex-shrink: 0;
  }

  .settings-content {
    padding: 16px;
  }

  .ss-sticky-save {
    margin-left: -16px;
    margin-right: -16px;
    padding: 12px 16px;
  }

  .btn-primary {
    max-width: none;
  }
}

@media (min-width: 1100px) {
  .grid-2 {
    grid-template-columns: repeat(3, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/adminManagement/Sitesettings.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;EACzC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kCAA0B;UAA1B,0BAA0B;EAC1B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;;;EAIE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Site Settings — admin panel layout */\n.settings-container {\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 4px 80px;\n  box-sizing: border-box;\n}\n\n.settings-container .page-header {\n  margin-bottom: 20px;\n}\n\n.settings-container .page-header h4 {\n  font-size: 1.35rem;\n  letter-spacing: 0.02em;\n  color: #0f172a;\n}\n\n.settings-container .page-subtitle {\n  color: #64748b;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.settings-card {\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n}\n\n.settings-form-inner {\n  padding: 0;\n}\n\n/* Quick controls — always on top */\n.ss-quick-bar {\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.ss-quick-bar__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.ss-quick-bar__title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.ss-quick-bar__hint {\n  font-size: 12px;\n  color: #64748b;\n  margin: 4px 0 0;\n}\n\n.ss-quick-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.ss-quick-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.ss-quick-card:hover {\n  border-color: #c7d2fe;\n  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.08);\n}\n\n.ss-quick-card--off {\n  border-color: #fecaca;\n  background: #fffbfb;\n}\n\n.ss-quick-card--off .ss-quick-card__label {\n  color: #991b1b;\n}\n\n.ss-quick-card__text {\n  flex: 1;\n  min-width: 0;\n}\n\n.ss-quick-card__label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.3;\n}\n\n.ss-quick-card__status {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  margin-top: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.ss-quick-card__status.on {\n  color: #059669;\n}\n\n.ss-quick-card__status.off {\n  color: #dc2626;\n}\n\n/* Tabs */\n.ss-tabs-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px 24px 0;\n  border-bottom: 1px solid #f1f5f9;\n  background: #fafbfc;\n}\n\n.ss-tab-btn {\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  background: transparent;\n  border: none;\n  border-radius: 8px 8px 0 0;\n  cursor: pointer;\n  transition: color 0.15s, background 0.15s;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n}\n\n.ss-tab-btn:hover {\n  color: #4f46e5;\n  background: rgba(79, 70, 229, 0.06);\n}\n\n.ss-tab-btn.active {\n  color: #4f46e5;\n  background: #fff;\n  border-bottom-color: #4f46e5;\n}\n\n.settings-content {\n  padding: 24px;\n}\n\n.ss-tab-panel {\n  animation: ssFadeIn 0.2s ease;\n}\n\n@keyframes ssFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ss-panel {\n  background: #fafbfc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px 22px;\n  margin-bottom: 20px;\n}\n\n.ss-panel:last-child {\n  margin-bottom: 0;\n}\n\n.ss-panel--warn {\n  background: #fffbeb;\n  border-color: #fde68a;\n}\n\n.ss-panel--danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n.settings-section {\n  margin-bottom: 0;\n}\n\n.section-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 16px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.section-subtitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #334155;\n  margin: 20px 0 12px;\n}\n\n.text-muted {\n  display: block;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.45;\n  margin-top: 6px;\n}\n\n.grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px 20px;\n}\n\n.grid-4 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.grid-span-full {\n  grid-column: 1 / -1;\n}\n\n.form-group {\n  margin-bottom: 0;\n}\n\n.form-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.form-input,\n.form-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  font-size: 14px;\n  color: #0f172a;\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  box-sizing: border-box;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.form-input {\n  height: 40px;\n}\n\n.form-input:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n.form-textarea {\n  min-height: 88px;\n  resize: vertical;\n  font-family: inherit;\n  line-height: 1.5;\n}\n\n.form-textarea:disabled,\n.form-input:disabled {\n  background: #f1f5f9;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n/* Toggle rows */\n.ss-toggle-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ss-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.ss-toggle-row__label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.switch-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 0;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background: #cbd5e1;\n  transition: 0.2s;\n  border-radius: 24px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background: #fff;\n  transition: 0.2s;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\ninput:checked + .slider {\n  background: #4f46e5;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(20px);\n}\n\n.switch-label {\n  font-size: 13px;\n  color: #475569;\n  font-weight: 500;\n}\n\n.maintenance-section {\n  background: transparent;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.logo-section {\n  background: transparent;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.landing-game-preview {\n  margin-top: 12px;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #f4f4f5;\n  max-width: 280px;\n}\n\n.landing-game-preview img {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 140px;\n  object-fit: cover;\n}\n\n.logo-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.logo-upload {\n  border: 2px dashed #cbd5e1;\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  background: #fff;\n  transition: border-color 0.15s;\n}\n\n.logo-upload:hover {\n  border-color: #6366f1;\n}\n\n.logo-upload input {\n  display: none;\n}\n\n.logo-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.logo-upload-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 18px;\n  background: #4f46e5;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.logo-upload-btn:hover {\n  background: #4338ca;\n}\n\n.logo-remove {\n  margin-top: 10px;\n  font-size: 13px;\n  color: #dc2626;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n/* Sticky save */\n.ss-sticky-save {\n  position: sticky;\n  bottom: 0;\n  z-index: 20;\n  display: flex;\n  gap: 12px;\n  padding: 16px 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(8px);\n  border-top: 1px solid #e2e8f0;\n  margin: 24px -24px -24px;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.btn-primary {\n  flex: 1;\n  max-width: 320px;\n  padding: 12px 24px;\n  background: #4f46e5;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #4338ca;\n}\n\n.btn-primary:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  padding: 12px 20px;\n  background: #f1f5f9;\n  color: #334155;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-radius: 50%;\n  border-top-color: #fff;\n  animation: ssSpin 0.8s linear infinite;\n}\n\n.btn-secondary .spinner {\n  border-color: rgba(51, 65, 85, 0.25);\n  border-top-color: #334155;\n}\n\n@keyframes ssSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Fake battles + danger + backup (unchanged structure) */\n.fake-battle-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.fake-battle-card,\n.danger-zone-card,\n.backup-zone-card {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n}\n\n.fake-battle-card--running {\n  border-color: #c7d2fe;\n}\n\n.fake-battle-card--running .fake-battle-header {\n  background: #eef2ff;\n}\n\n.danger-zone-card {\n  border-color: #fecaca;\n}\n\n.fake-battle-header,\n.danger-zone-header,\n.backup-zone-header {\n  padding: 16px 20px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.danger-zone-header {\n  background: #fef2f2;\n  border-bottom-color: #fecaca;\n}\n\n.backup-zone-header {\n  background: #eff6ff;\n  border-bottom-color: #bfdbfe;\n}\n\n.fake-battle-title,\n.danger-zone-title,\n.backup-zone-title {\n  font-size: 15px;\n  font-weight: 700;\n  margin: 0;\n  color: #0f172a;\n}\n\n.danger-zone-title {\n  color: #991b1b;\n}\n\n.backup-zone-title {\n  color: #1e40af;\n}\n\n.fake-battle-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 12px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.stat-value {\n  font-size: 18px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.stat-label {\n  font-size: 11px;\n  color: #64748b;\n  text-transform: uppercase;\n}\n\n.battle-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px 20px;\n}\n\n.badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.badge-flash {\n  background: #fef3c7;\n  color: #b45309;\n}\n.badge-ten {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n.badge-high {\n  background: #dcfce7;\n  color: #15803d;\n}\n.badge-regular {\n  background: #f3e8ff;\n  color: #7c3aed;\n}\n\n.toggle-switch {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.toggle-btn {\n  width: 44px;\n  height: 24px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  position: relative;\n  transition: background 0.2s;\n}\n\n.toggle-btn.enabled {\n  background: #10b981;\n}\n.toggle-btn.disabled {\n  background: #cbd5e1;\n}\n\n.toggle-btn:after {\n  content: \"\";\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  top: 2px;\n  transition: left 0.2s, right 0.2s;\n}\n\n.toggle-btn.enabled:after {\n  right: 2px;\n  left: auto;\n}\n.toggle-btn.disabled:after {\n  left: 2px;\n}\n\n.backup-zone-collapsed {\n  margin-bottom: 16px;\n}\n\n.btn-backup-toggle {\n  width: 100%;\n  border: 1px dashed #93c5fd;\n  background: #f8fafc;\n  color: #1d4ed8;\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.danger-zone-body,\n.backup-zone-body {\n  padding: 16px 20px;\n}\n\n.danger-zone-desc,\n.backup-zone-desc {\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.5;\n  margin: 0 0 14px;\n}\n\n.purge-preview-box {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 12px 14px;\n  margin-bottom: 14px;\n  font-size: 12px;\n}\n\n.danger-actions,\n.backup-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.btn-danger-outline,\n.btn-danger-solid,\n.btn-backup-outline,\n.btn-backup-solid {\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-danger-outline {\n  border: 1px solid #dc2626;\n  background: #fff;\n  color: #dc2626;\n}\n\n.btn-danger-solid {\n  border: none;\n  background: #dc2626;\n  color: #fff;\n}\n\n.btn-backup-outline {\n  border: 1px solid #2563eb;\n  background: #fff;\n  color: #2563eb;\n}\n\n.btn-backup-solid {\n  border: none;\n  background: #2563eb;\n  color: #fff;\n}\n\n.btn-backup-hide {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n@media (max-width: 900px) {\n  .fake-battle-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .grid-2,\n  .grid-4,\n  .logo-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .ss-quick-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .ss-tabs-wrap {\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .ss-tab-btn {\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  .settings-content {\n    padding: 16px;\n  }\n\n  .ss-sticky-save {\n    margin-left: -16px;\n    margin-right: -16px;\n    padding: 12px 16px;\n  }\n\n  .btn-primary {\n    max-width: none;\n  }\n}\n\n@media (min-width: 1100px) {\n  .grid-2 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
